import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";
import { CustomFormAddress } from "@nishtech/Handlers/CustomForms/CustomRequestAccountForm";

const customFormsBaseUrl = "api/v1/customforms";
const customRequestAccountUrl = "customRequestAccount";

export interface CustomRequestAccountApiParameter extends ApiParameter {
    customRequestAccountModel: CustomRequestAccountModel;
}

export interface CustomRequestAccountModel extends BaseModel {
    recepientEmails:string;
    tradeName: string;
    legalBusinessName: string;
    billToAddress:CustomFormAddress;
    billToPhone: string;
    isShipToSameAsBillTo: boolean;
    shipToAddres:CustomFormAddress;
    shipToPhone: string;
    emailAddress: string;
    salesTaxId: string;
    allowToReviewBusinessCredit: boolean;
    contactName: string;
}


export async function customRequestAccount(parameter: CustomRequestAccountApiParameter): Promise<ServiceResult<CustomRequestAccountModel>> {
     try {
            const customRequestAccountModel = await post<CustomRequestAccountModel>(`${customFormsBaseUrl}/${customRequestAccountUrl}`, parameter.customRequestAccountModel);
            return {
                successful: true,
                result: customRequestAccountModel
            };
        } catch (error) {
            if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
                return {
                    successful: false,
                    errorMessage: error.errorJson.message,
                };
            }
            throw error;
        }
}

